import { CatalogProductResponse } from '../models/product-catalog.model';

// Onboarding to ALM of non-ocean products have started. Below is to ensure that if product comes from SAP(ALM), we do not show it from our stored json file.
// This is temporary. Once we remove the JSON, we will be able to get rid of this filter.
export function deduplicateNonSapProducts(
  sapProducts: { code: string; name: string }[],
  nonSapProducts: CatalogProductResponse[]
): CatalogProductResponse[] {
  const sapCodes = new Set(sapProducts.map(p => p.code.toLowerCase()));
  const sapNames = new Set(sapProducts.map(p => p.name.toLowerCase()));
  return nonSapProducts.filter(
    p => !sapCodes.has((p.code ?? '').toLowerCase()) && !sapNames.has((p.name ?? '').toLowerCase())
  );
}
